import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import AutoGrowTextarea from "@/components/AutoGrowTextarea";
import ItemMasterPicker from "./ItemMasterPicker";
import { computeItem } from "./quoteUtils";
import { rupee } from "@/lib/format";

export default function QuoteItemRow({ it, idx, canRemove, onChange, onRemove }) {
  const c = computeItem(it);
  return (
    <div className="border border-[#E2E8F0] rounded-md px-2 py-2 bg-white min-w-[700px]" data-testid={`quote-item-${idx}`}>
      <div className="flex items-center gap-1.5">
        <span className="w-5 shrink-0 text-center text-[11px] font-mono text-[#94A3B8]">{idx + 1}</span>
        <Input value={it.item_name} onChange={(e) => onChange({ item_name: e.target.value })}
          placeholder="Item name" className="h-8 text-sm flex-1 min-w-[150px]" data-testid={`quote-item-name-${idx}`} />
        <ItemMasterPicker testId={`quote-item-master-${idx}`}
          onPick={(r) => onChange({ item_name: r.item_name, hsn: r.hsn || "", description: r.description || "", unit_price: r.rate ?? "", gst_inclusive: !!r.gst_inclusive })} />
        <Input value={it.hsn} onChange={(e) => onChange({ hsn: e.target.value })} className="h-8 w-20 font-mono text-xs" placeholder="HSN" data-testid={`quote-item-hsn-${idx}`} />
        <Input type="number" min="0" value={it.qty} onChange={(e) => onChange({ qty: e.target.value })} className="h-8 w-14 text-center px-1" placeholder="Qty" data-testid={`quote-item-qty-${idx}`} />
        <Input type="number" min="0" value={it.unit_price} onChange={(e) => onChange({ unit_price: e.target.value })} className="h-8 w-24 text-right font-mono" placeholder="Rate" data-testid={`quote-item-price-${idx}`} />
        <div className="flex flex-col items-center w-12 shrink-0" title="Rate incl. of GST">
          <span className="text-[9px] font-mono uppercase text-[#94A3B8] leading-none mb-0.5">Incl</span>
          <Switch checked={it.gst_inclusive} onCheckedChange={(v) => onChange({ gst_inclusive: v })} data-testid={`quote-item-incl-${idx}`} />
        </div>
        <div className="w-28 shrink-0 text-right">
          <div className="font-mono text-sm font-semibold" data-testid={`quote-item-total-${idx}`}>{rupee(c.line_total)}</div>
          <div className="text-[10px] text-[#64748B] font-mono leading-none">GST {rupee(c.gst)}</div>
        </div>
        {canRemove ? (
          <Button type="button" variant="ghost" size="icon" onClick={onRemove} className="h-8 w-8 shrink-0" data-testid={`quote-item-remove-${idx}`}>
            <X className="w-4 h-4 text-[#EF4444]" />
          </Button>
        ) : <span className="w-8 shrink-0" />}
      </div>
      <div className="mt-1 pl-6">
        <AutoGrowTextarea value={it.description} onChange={(e) => onChange({ description: e.target.value })}
          placeholder="Description / specs (optional)" className="w-full max-w-3xl text-xs py-1" data-testid={`quote-item-desc-${idx}`} />
      </div>
    </div>
  );
}
